import cx from 'classnames'
import { CircleHelp, FileText, SquareArrowOutUpRight } from 'lucide-react'

import { Icon } from './Icon'

export const DocumentationLink = ({
  className,
  direction = 'right',
  href,
  icon = 'docs',
  label = 'Docs',
  tone = 'default',
}) => {
  const resolvedDirection = direction === 'left' ? 'left' : 'right'
  const resolvedTone = tone === 'inverse' ? 'inverse' : 'default'
  const DefaultIcon = icon === 'help' ? CircleHelp : FileText
  const iconSize = icon === 'help' ? 18 : 19

  return (
    <span className={cx('ds-docs-link-slot', className)}>
      <a
        className="ds-docs-link"
        data-direction={resolvedDirection}
        data-tone={resolvedTone}
        href={href}
        rel="noreferrer"
        target="_blank"
      >
        <span aria-hidden="true" className="ds-docs-link-icon">
          <Icon as={DefaultIcon} className="ds-docs-link-default-icon" size={iconSize} strokeWidth={1.6} />
          <Icon as={SquareArrowOutUpRight} className="ds-docs-link-external-icon" size={iconSize} strokeWidth={1.6} />
        </span>
        <span className="ds-docs-link-label">{label}</span>
      </a>
    </span>
  )
}
